
import styled, { css } from "styled-components";
import { Form } from "react-bootstrap";

const Input = styled(Form.Control)`
  border-radius: 0;
  height: 3rem;
  ${(props) =>
    props.nolabel &&
    css`
      margin-top: 2rem;
    `}
  /* margin-top: 2rem; */
`;

export default Input;